export default "__VITE_ASSET__Dfnj4flc__"